$(document).ready(function () {
    'use strict';

    const franchiseSlider = $(".sliderWrapper .slides");

    if (franchiseSlider.length > 0) {
        franchiseSlider.slick({
            centerPadding: 0,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            fade: true,
            cssEase: 'linear',
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
        });

        const first_slide = franchiseSlider.find('li').first();
        const light_scheme = first_slide.find('.contentWrapper').data("light");

        if (parseInt(light_scheme) === 1) {
            $("body").addClass("lightScheme");
        }

        if ($(".sliderWrapper .slides li").first())

        franchiseSlider.on('beforeChange', function (_, __, ___, nextSlide) {
            var light_scheme = $(this).find(".slide[data-slick-index=" + nextSlide + "] .contentWrapper").data("light"),
                body = $("body"),
                darkLogo = $(".darkLogo"),
                lightLogo = $(".lightLogo");

            if (parseInt(light_scheme) === 1) {

                if (!body.hasClass("lightScheme")) {
                    $("body").addClass("lightScheme");
                }

                lightLogo.hide();
                darkLogo.fadeIn(500);

            } else {

                if (body.hasClass("lightScheme")) {
                    $("body").removeClass("lightScheme");
                }

                darkLogo.hide();
                lightLogo.fadeIn(500);
            }
        });
    }



    const franchiseCarSlider = $('.js_franchiseCarSlider');

    if (franchiseCarSlider.length > 0) {
        franchiseCarSlider.slick({
            centerPadding: 0,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            responsive: [
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },

                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }

    const photoSlider = $('.js_photoSlider');

    if (photoSlider.length > 0) {
        photoSlider.slick({
            centerPadding: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            responsive: [
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 670,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }

    const ctaSlider = $('.js_franchiseCtas');

    if (ctaSlider.length > 0) {
        ctaSlider.slick({
            centerPadding: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            responsive: [
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 670,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }

    const franchiseRangeSlider = $('.js_franchiseRangeSlider');

    if (franchiseRangeSlider.length > 0) {
        franchiseRangeSlider.slick({
            centerPadding: 0,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            nextArrow: '<a class="slick-arrow slick-next"></a>',
            prevArrow: '<a class="slick-arrow slick-prev"></a>',
            responsive: [
                {
                    breakpoint: 1150,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },

                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
});
